const PUBLIC_ROUTE_PREFIXES = [
  '/login',
  '/register',
  '/reset-password',
  '/invite/',
  '/forgot-password',
  '/events/guest',
  '/privacy',
  '/terms',
  '/release-notes',
  '/docs'
];

export function isLandingRoute(path) {
  return path === '/' || path === '/home';
}

export function isPublicRoute(path) {
  return PUBLIC_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function isProtectedRoute(path) {
  return !isLandingRoute(path) && !isPublicRoute(path);
}
